let countdown = {
    init: () => {
        const countdowns = document.querySelectorAll('.js-count-down');

        const getTimeRemaining = (endtime) => {
            var t = Date.parse(endtime) - Date.parse(new Date());
            var seconds = Math.floor((t / 1000) % 60);
            var minutes = Math.floor((t / 1000 / 60) % 60);
            var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
            var days = Math.floor(t / (1000 * 60 * 60 * 24));
            return {
                'total': t,
                'days': days,
                'hours': hours,
                'minutes': minutes,
                'seconds': seconds
            };
        }

        const initializeCountdown = (countdown, endtime) => {
            var daysSpan = countdown.querySelector('.days');
            var hoursSpan = countdown.querySelector('.hours');
            var minutesSpan = countdown.querySelector('.minutes');
            var secondsSpan = countdown.querySelector('.seconds');

            const updateClock = () => {
                var t = getTimeRemaining(endtime);

                daysSpan.innerHTML = t.days;
                hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
                minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
                secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

                if (t.total <= 0) {
                    clearInterval(timeinterval);
                }
            }

            updateClock();
            var timeinterval = setInterval(updateClock, 1000);
        }

        if (countdowns) {
            for (const countdown of countdowns) {
                const dateParts = countdown.dataset.traveldeparturetime.split(/\.|\s/);
                const departureTime = new Date(dateParts[2], dateParts[1] - 1, dateParts[0], dateParts[3], dateParts[4], dateParts[5]);
                initializeCountdown(countdown, departureTime);
            }
        }
    }
}

export default countdown;